export default {
    idDonor: '',
    temporaryAccount: true,
    firstName: '',
    lastName: '',
    dob: '',
    mobilePhone: '',
    phoneCode: '',
    email: '',
    street: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    bloodType: '',
    smsOptedOut: '',
    donorId: '',
    prohibitingStatuse: '',
//    numberOfPointsEarned: '',
    pointsTotal: '',
    sumRewardsPoints: '',
    lifetimeDonations: '',
    lifetime_donations_wb_c: '',
    lifetime_donations_plt_c: '',
    lifetime_donations_drbc_c: '',
    lifetime_donations_alyrp_c: '',
    lifetime_donations_total_c: '',

    determinationCoordinates: {
        zipCodeDeterminationOfCoordinates: false,
        errorZipLocation: false,
    },
    previousDonation: [],
    futureDonates: [],

    donorCharacteristics: [],
    donorEligibility: [],
    phoneFormat: 'USA Format',
    newDonor: true,
}
